// lang
export const setLang = (lang: string) => {
  localStorage.setItem("lang", lang);
};

export const getLang = (): string => {
  return localStorage.getItem("lang") || "";
};

export const removeLang = () => {
  localStorage.removeItem("lang");
};
